import script from "./ApiDocsRichText.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiDocsRichText.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__